import React, { useState, useEffect, useRef } from "react";

import { Row, Col, Input, Button, Alert, Container, Label } from "reactstrap";
import { apiReq } from "../../utils/utils";
import * as url from "../../utils/urls";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import { Link } from "react-router-dom";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";
import EEAA_LOGO from "../../assets/images/eeaa.png";
import Swal from "sweetalert2";

const VerifyLogin = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { token } = queryString.parse(location.search);

  // Verify token for password
  const verifyToken = () => {
    setIsLoading(true);
    apiReq(
      url.VERIFY_MAGIC_LINK,
      {
        token,
      },
      "post",
      {}
    )
      .then((res) => {
        // console.log(res);
        if (res.success) {
          localStorage.setItem("infoSalonsUser", JSON.stringify(res.data));
          localStorage.removeItem("infoSalonsSecret");
          dispatch({ type: "USER_LOGIN", payload: res.data });
          history.push("/");
        } else {
          setIsLoading(false);
          Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.success === false) {
          setIsSuccess(false);
          Swal.fire({
            title: "Error",
            text: err.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  useEffect(() => {
    verifyToken();
  }, [token]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const password = useRef({});
  password.current = watch("password", "");

  const onSubmit = (data) => {
    setIsLoading(true);
    apiReq(
      url.CHANGE_PASSWORD_DIRECT,
      {
        user: userDetails._id,
        password: data.password,
      },
      "post",
      {
        Authorization: `Bearer ${userDetails.token}`,
      }
    )
      .then((res) => {
        console.log(res);
        if (res.success) {
          setIsSuccess(true);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          history.push("/login");
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.apiStatus.statusMessage);
      });
  };

  useEffect(() => {
    document.body.classList.add("auth-body-bg");

    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, []);
  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={8}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={5}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="">
                              <img
                                src={logodark}
                                alt=""
                                height="50"
                                className="auth-logo logo-dark mx-auto"
                              />
                              <img
                                src={logolight}
                                alt=""
                                height="50"
                                className="auth-logo logo-light mx-auto"
                              />
                            </Link>
                          </div>
                        </div>

                        <div className="p-2 mt-5">
                          <Link to="/login" className="btn btn-primary w-100">
                            Login
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="authentication-bg">
                <div
                  className="login_options d-flex align-items-center"
                  style={{ height: "100%" }}
                >
                  <div className="options_inner">
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center mb-0">Recognized as</p>
                    <p className="text-center">
                      EEAA Best Innovation in Event Tech Winner
                    </p>
                    <div className="login_option_logo_wrapper">
                      <div className="login_option_logo d-flex justify-content-center align-items-center">
                        <img src={EEAA_LOGO} alt={"EEAA_LOGO"} width="200" />
                      </div>
                      <div className="sap_line"></div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center" style={{ fontSize: 18 }}>
                      Recognized by customers across the world as a leader in
                      tech event, online & mobile solutions.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VerifyLogin;
